// Generated by scripts/generate-rudder-mcp-tool-descriptors.ts. Do not edit by hand.
import type { AgentCliCapability } from "./agent-v1-registry.js";
export const AGENT_CLI_CAPABILITIES: AgentCliCapability[] = [
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent me",
    "contract": "agent-v1",
    "description": "Show the authenticated agent identity and budget.",
    "id": "agent.me",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent inbox",
    "contract": "agent-v1",
    "description": "List the compact assignee and reviewer work inbox for the authenticated agent.",
    "id": "agent.inbox",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "organization",
    "command": "rudder org members --org-id <id> [--query <text>] [--type <human|agent|all>] [--limit <n>] [--cursor <cursor>]",
    "contract": "agent-v1",
    "description": "List active visible human and agent members in the authenticated organization.",
    "id": "organization.members.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent capabilities",
    "contract": "agent-v1",
    "description": "List the stable Rudder agent command contract.",
    "id": "agent.capabilities",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent list --org-id <id>",
    "contract": "compat",
    "description": "List agents for an organization.",
    "id": "agent.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent get <agent-id-or-shortname-or-agt-ref>",
    "contract": "compat",
    "description": "Read one agent by id, shortname, or agt_<uuid-prefix> short ref.",
    "id": "agent.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "agent",
    "command": "rudder agent update [agent-id] [--title <title>] [--description <text>]",
    "contract": "agent-v1",
    "description": "Update an agent's identity fields; defaults to the authenticated agent.",
    "id": "agent.update",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "agent",
    "command": "rudder agent skills create [agent-id] --name <name> [--enable]",
    "contract": "agent-v1",
    "description": "Create an agent-private skill package under AGENT_HOME/skills.",
    "id": "agent.skills.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "agent",
    "command": "rudder agent skills enable <agent-id> <selection-ref...>",
    "contract": "agent-v1",
    "description": "Add skill selections to an agent without replacing existing enabled skills.",
    "id": "agent.skills.enable",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "agent",
    "command": "rudder agent skills sync <agent-id>",
    "contract": "agent-v1",
    "description": "Sync the desired enabled skill set for an agent.",
    "id": "agent.skills.sync",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "goal",
    "command": "rudder goal list [--lifecycle <draft|active|closed|all>] [--focus <true|false>] [--facet <facet>] [--limit <n>]",
    "contract": "agent-v1",
    "description": "Discover Goals owned by the authenticated Agent; defaults to active Goals and returns current progress, next step, and attention state.",
    "id": "goal.list",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "goal",
    "command": "rudder goal context <goal-id>",
    "contract": "agent-v1",
    "description": "Read the owned Goal agreement and current operating context before acting: contract revision, criteria, boundaries, progress, next step, attention, proposals, and recent feedback.",
    "id": "goal.context",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "goal",
    "command": "rudder goal progress <goal-id> --summary <text> --evidence-refs <json> --idempotency-key <key>",
    "contract": "agent-v1",
    "description": "Record evidence-backed progress for a Goal owned by the authenticated Agent and attribute it to the current Run.",
    "id": "goal.progress",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "goal",
    "command": "rudder goal checkpoint <goal-id> --summary <text> --evidence-refs <json> --expected-plan-revision <n> --continuation <json> --idempotency-key <key>",
    "contract": "agent-v1",
    "description": "Atomically persist a Goal checkpoint, optional Plan revision, continuation, checkpoint activity, and eligible automatic continuation wake.",
    "id": "goal.checkpoint",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "goal",
    "command": "rudder goal change propose <goal-id> --contract-revision <n> --after-contract <json> --rationale <text> --idempotency-key <key>",
    "contract": "agent-v1",
    "description": "Propose a reviewable change to the current Goal contract when evidence shows its outcome, criteria, boundaries, or deadlines should change.",
    "id": "goal.change.propose",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "goal",
    "command": "rudder goal result propose <goal-id> --contract-revision <n> --criteria <json> --evidence-refs <json> --risk-summary <text> --idempotency-key <key>",
    "contract": "agent-v1",
    "description": "Submit an evidence-backed Goal result for mandatory human acceptance without closing the Goal.",
    "id": "goal.result.propose",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "agent",
    "command": "rudder agent hire --org-id <id> --payload <json>",
    "contract": "compat",
    "description": "Create a new hire using the canonical hire workflow.",
    "id": "agent.hire",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent config index",
    "contract": "compat",
    "description": "Read the installed agent runtime configuration index.",
    "id": "agent.config.index",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent config doc <agent-runtime-type>",
    "contract": "compat",
    "description": "Read adapter-specific configuration guidance for one runtime.",
    "id": "agent.config.doc",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent config list --org-id <id>",
    "contract": "compat",
    "description": "List redacted agent configuration snapshots for an organization.",
    "id": "agent.config.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent config get <agent-id-or-shortname>",
    "contract": "compat",
    "description": "Read one redacted agent configuration snapshot by id or shortname.",
    "id": "agent.config.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "agent",
    "command": "rudder agent icons",
    "contract": "compat",
    "description": "List legacy named agent icons for compatibility/debugging; normal create and hire payloads should omit icon.",
    "id": "agent.icons",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue get <issue>",
    "contract": "agent-v1",
    "description": "Read a full issue by UUID or identifier.",
    "id": "issue.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue list --org-id <id>",
    "contract": "agent-v1",
    "description": "List issues with optional status, assignee, and project filters without requiring a search query.",
    "id": "issue.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue search <query> [--org-id <id>]",
    "contract": "agent-v1",
    "description": "Search issues with the server-side issue index across title, identifier, description, and comments.",
    "id": "issue.search",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue context <issue> [--wake-comment-id <comment-id-or-cmt-ref>]",
    "contract": "agent-v1",
    "description": "Read the compact heartbeat context for an issue; wake comments may be addressed by full id or cmt_<uuid-prefix>.",
    "id": "issue.context",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue checkout <issue>",
    "contract": "agent-v1",
    "description": "Atomically checkout an issue for the current or specified agent.",
    "id": "issue.checkout",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue comment <issue> --body-file <path> [--image <path>]",
    "contract": "agent-v1",
    "description": "Add a comment to an issue, optionally uploading images and appending Markdown image links.",
    "id": "issue.comment",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue comments list <issue> [--after <comment-id-or-cmt-ref>]",
    "contract": "agent-v1",
    "description": "List issue comments, optionally only newer comments after a full comment id or cmt_<uuid-prefix> with --after.",
    "id": "issue.comments.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue comments get <issue> <comment-id-or-cmt-ref>",
    "contract": "agent-v1",
    "description": "Read one issue comment by full id or cmt_<uuid-prefix> scoped to the issue.",
    "id": "issue.comments.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue update <issue> ... [--comment-file <path>] [--image <path>]",
    "contract": "agent-v1",
    "description": "Apply generic issue updates when workflow commands are not enough, optionally uploading images for the update comment.",
    "id": "issue.update",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue review <issue> --decision <decision> --comment-file <path>",
    "contract": "agent-v1",
    "description": "Record a structured reviewer decision with a required comment.",
    "id": "issue.review",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue commit <issue> --sha <sha> --message <subject>",
    "contract": "agent-v1",
    "description": "Report a code commit created during issue work as structured issue activity.",
    "id": "issue.commit",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue done <issue> --comment-file <path> [--image <path>]",
    "contract": "agent-v1",
    "description": "Mark an issue done with a required completion comment, optionally uploading images.",
    "id": "issue.done",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue block <issue> --comment-file <path> [--image <path>]",
    "contract": "agent-v1",
    "description": "Request human assistance after bounded recovery attempts; repeated matching claims are audited before the Issue becomes blocked.",
    "id": "issue.block",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "project",
    "command": "rudder project list --org-id <id>",
    "contract": "agent-v1",
    "description": "List projects in an organization.",
    "id": "project.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "project",
    "command": "rudder project get <project-id-or-shortname> [--org-id <id>]",
    "contract": "agent-v1",
    "description": "Read one project by ID or shortname.",
    "id": "project.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "project",
    "command": "rudder project create --org-id <id> --name <name>",
    "contract": "agent-v1",
    "description": "Create a project in the organization.",
    "id": "project.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "project",
    "command": "rudder project update <project-id-or-shortname> [--org-id <id>]",
    "contract": "agent-v1",
    "description": "Update mutable project fields such as name, description, status, goals, lead agent, target date, color, or archivedAt.",
    "id": "project.update",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "user",
    "command": "rudder user activity --user me --since today --json",
    "contract": "agent-v1",
    "description": "Read a user-centered activity ledger with safe excerpts and provenance across chats, issue comments, approval comments, and user actor activity.",
    "id": "user.activity",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "library",
    "command": "rudder library file list [directory]",
    "contract": "agent-v1",
    "description": "List Library files and folders; file rows include `libraryEntryId` when a strong reference can be generated.",
    "id": "library.file.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "library",
    "command": "rudder library file get <path>",
    "contract": "agent-v1",
    "description": "Fallback read when local filesystem access is unavailable; JSON includes `mentionHref` and `markdownLink`.",
    "id": "library.file.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "library",
    "command": "rudder library file ref <path>",
    "contract": "agent-v1",
    "description": "Return the stable Markdown reference for one Library file without printing file content.",
    "id": "library.file.ref",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "library",
    "command": "rudder library file link <path>",
    "contract": "agent-v1",
    "description": "Compatibility alias for `rudder library file ref <path>`.",
    "id": "library.file.link",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "library",
    "command": "rudder library file put <path> --body-file <path>",
    "contract": "agent-v1",
    "description": "Fallback create/update when local filesystem access is unavailable; JSON includes `mentionHref` and `markdownLink`.",
    "id": "library.file.put",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "issue",
    "command": "rudder issue create --org-id <id> ... [--label-id <id> ...] [--label <name> ...]",
    "contract": "agent-v1",
    "description": "Create a new issue or subtask with the generic issue surface; agent-created issues default to the creating agent when no assignee is supplied.",
    "id": "issue.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "issue",
    "command": "rudder issue labels list --org-id <id>",
    "contract": "compat",
    "description": "List organization issue labels available for issue creation.",
    "id": "issue.labels.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "approval",
    "command": "rudder approval get <approval-id>",
    "contract": "agent-v1",
    "description": "Read one approval request.",
    "id": "approval.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "approval",
    "command": "rudder approval create --org-id <id> --type <type> --payload <json>",
    "contract": "compat",
    "description": "Create a new approval request.",
    "id": "approval.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "approval",
    "command": "rudder approval issues <approval-id>",
    "contract": "agent-v1",
    "description": "List the issues linked to an approval.",
    "id": "approval.issues",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "approval",
    "command": "rudder approval comment <approval-id> --body-file <path>",
    "contract": "agent-v1",
    "description": "Add a comment to an approval.",
    "id": "approval.comment",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "approval",
    "command": "rudder approval resubmit <approval-id> [--payload <json>]",
    "contract": "compat",
    "description": "Resubmit a revision-requested approval, optionally with updated payload.",
    "id": "approval.resubmit",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "skill",
    "command": "rudder skill list --org-id <id>",
    "contract": "agent-v1",
    "description": "List organization-visible skills.",
    "id": "skill.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "skill",
    "command": "rudder skill search <query> --org-id <id>",
    "contract": "agent-v1",
    "description": "Search organization-visible skills by name, slug, description, or source.",
    "id": "skill.search",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "skill",
    "command": "rudder skill get <skill-id> --org-id <id>",
    "contract": "agent-v1",
    "description": "Read one organization skill detail.",
    "id": "skill.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "skill",
    "command": "rudder skill file <skill-id> --org-id <id> [--path SKILL.md]",
    "contract": "agent-v1",
    "description": "Read one file from an organization skill package.",
    "id": "skill.file",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "skill",
    "command": "rudder skill import --org-id <id> --source <source>",
    "contract": "agent-v1",
    "description": "Import a skill package into the organization skill library.",
    "id": "skill.import",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "skill",
    "command": "rudder skill scan-local --org-id <id> [--roots <csv>]",
    "contract": "agent-v1",
    "description": "Scan local roots for skill packages and import new ones.",
    "id": "skill.scan-local",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "skill",
    "command": "rudder skill scan-projects --org-id <id> [--project-ids <csv>] [--workspace-ids <csv>]",
    "contract": "agent-v1",
    "description": "Scan the org workspace and any legacy project workspace records for skill packages and import new ones.",
    "id": "skill.scan-projects",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "plugin",
    "command": "rudder plugin search <query> --org-id <id>",
    "contract": "agent-v1",
    "description": "Search installed, local, and discoverable Rudder plugins.",
    "id": "plugin.search",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "plugin",
    "command": "rudder plugin get <plugin-id> --org-id <id>",
    "contract": "agent-v1",
    "description": "Read an installed plugin, including its components and current setup state; use this to resolve plugin:// references.",
    "id": "plugin.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "browser",
    "command": "rudder browser tabs",
    "contract": "agent-v1",
    "description": "List Browser tabs owned by the current Rudder agent run.",
    "id": "browser.tabs",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "browser",
    "command": "rudder browser user-tabs",
    "contract": "agent-v1",
    "description": "List user-visible tabs currently open in Rudder's built-in Browser without taking control of them.",
    "id": "browser.user-tabs",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser open <url>",
    "contract": "agent-v1",
    "description": "Open a run-owned tab in the Rudder Browser.",
    "id": "browser.open",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser navigate <tab-id> <url>",
    "contract": "agent-v1",
    "description": "Navigate a run-owned Rudder Browser tab.",
    "id": "browser.navigate",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser back <tab-id>",
    "contract": "agent-v1",
    "description": "Navigate a run-owned Rudder Browser tab back in history.",
    "id": "browser.back",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser forward <tab-id>",
    "contract": "agent-v1",
    "description": "Navigate a run-owned Rudder Browser tab forward in history.",
    "id": "browser.forward",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser reload <tab-id>",
    "contract": "agent-v1",
    "description": "Reload a run-owned Rudder Browser tab.",
    "id": "browser.reload",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser viewport --action <get|set|reset> [--width <px> --height <px>]",
    "contract": "agent-v1",
    "description": "Inspect, set, or reset the responsive viewport for the current Rudder Browser run.",
    "id": "browser.viewport",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser visibility [--visible <true|false>]",
    "contract": "agent-v1",
    "description": "Inspect or change whether the current run's selected Rudder Browser tab is visible.",
    "id": "browser.visibility",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser snapshot <tab-id> [--input <json>]",
    "contract": "agent-v1",
    "description": "Capture a bounded DOM and accessibility-oriented snapshot, including frame structure and ephemeral node ids.",
    "id": "browser.snapshot",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser locator <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Perform read-only bounded Browser locator text, attribute, state, count, or wait operations.",
    "id": "browser.locator",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser cua <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Perform trusted coordinate mouse, scroll, drag, keyboard, and text input in a run-owned Browser tab.",
    "id": "browser.cua",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser dom-cua <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Inspect a bounded read-only DOM snapshot with ephemeral node ids.",
    "id": "browser.dom-cua",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser dialog <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Inspect, accept, or dismiss the active JavaScript dialog in a run-owned Browser tab.",
    "id": "browser.dialog",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser clipboard --input <json>",
    "contract": "agent-v1",
    "description": "Read or write the isolated virtual clipboard for the current Browser run without touching the OS clipboard.",
    "id": "browser.clipboard",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser logs <tab-id> [--input <json>]",
    "contract": "agent-v1",
    "description": "Read bounded console and runtime logs captured for a run-owned Browser tab.",
    "id": "browser.logs",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser download <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Download explicit locator media without dispatching page input into a bounded run-owned artifact.",
    "id": "browser.download",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser assets <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "List page assets or bundle an explicit bounded selection into a run-owned temporary artifact.",
    "id": "browser.assets",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser content <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Export current page content or an eligible Google Workspace document into a bounded run-owned artifact.",
    "id": "browser.content",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser wait <tab-id> --input <json>",
    "contract": "agent-v1",
    "description": "Wait for bounded URL, text, disappearance, or time conditions in a run-owned Browser tab.",
    "id": "browser.wait",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "browser",
    "command": "rudder browser read <tab-id>",
    "contract": "agent-v1",
    "description": "Read a structured snapshot from a run-owned Rudder Browser tab.",
    "id": "browser.read",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser click <tab-id> <ref>",
    "contract": "agent-v1",
    "description": "Click an element reference returned by Rudder Browser read.",
    "id": "browser.click",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser type <tab-id> <ref> --text <text>",
    "contract": "agent-v1",
    "description": "Type into an element reference in a run-owned Rudder Browser tab.",
    "id": "browser.type",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "browser",
    "command": "rudder browser screenshot <tab-id> [--input <json>]",
    "contract": "agent-v1",
    "description": "Capture a screenshot of a run-owned Rudder Browser tab.",
    "id": "browser.screenshot",
    "mutating": false,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "browser",
    "command": "rudder browser close <tab-id>",
    "contract": "agent-v1",
    "description": "Close a run-owned Rudder Browser tab.",
    "id": "browser.close",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": true,
    "requiresRunId": true
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "automation",
    "command": "rudder automation list --org-id <id>",
    "contract": "agent-v1",
    "description": "List automations for an organization with compact local filters.",
    "id": "automation.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "automation",
    "command": "rudder automation get <automation-id>",
    "contract": "agent-v1",
    "description": "Read one automation detail including triggers and recent runs.",
    "id": "automation.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "automation",
    "command": "rudder automation runs <automation-id>",
    "contract": "agent-v1",
    "description": "List recent runs for one automation.",
    "id": "automation.runs",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "automation",
    "command": "rudder automation triggers list <automation-id>",
    "contract": "agent-v1",
    "description": "List triggers configured for one automation.",
    "id": "automation.triggers.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation triggers create <automation-id> --kind <kind>",
    "contract": "agent-v1",
    "description": "Create a schedule, webhook, or API trigger through the governed automation API.",
    "id": "automation.triggers.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation triggers update <trigger-id>",
    "contract": "agent-v1",
    "description": "Update an automation trigger through the governed automation API.",
    "id": "automation.triggers.update",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation triggers delete <trigger-id>",
    "contract": "agent-v1",
    "description": "Delete an automation trigger through the governed automation API.",
    "id": "automation.triggers.delete",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation triggers rotate-secret <trigger-id>",
    "contract": "agent-v1",
    "description": "Rotate an automation webhook trigger secret through the governed automation API.",
    "id": "automation.triggers.rotate-secret",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation create --org-id <id> --title <title> --assignee-agent-id <id>",
    "contract": "agent-v1",
    "description": "Create an automation through the governed automation API.",
    "id": "automation.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation update <automation-id>",
    "contract": "agent-v1",
    "description": "Update automation fields through the governed automation API.",
    "id": "automation.update",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation enable <automation-id>",
    "contract": "agent-v1",
    "description": "Enable an automation by setting status to active.",
    "id": "automation.enable",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation disable <automation-id>",
    "contract": "agent-v1",
    "description": "Disable an automation by setting status to paused.",
    "id": "automation.disable",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "automation",
    "command": "rudder automation run <automation-id>",
    "contract": "agent-v1",
    "description": "Trigger a manual automation run.",
    "id": "automation.run",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "chat",
    "command": "rudder chat list --org-id <id>",
    "contract": "agent-v1",
    "description": "List chat conversations without dumping full message history.",
    "id": "chat.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "chat",
    "command": "rudder chat search <query> --org-id <id>",
    "contract": "agent-v1",
    "description": "Search chats with bounded snippets and optional scope filtering.",
    "id": "chat.search",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "chat",
    "command": "rudder chat get <chat-id-or-cht-ref>",
    "contract": "agent-v1",
    "description": "Read one chat conversation record.",
    "id": "chat.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "chat",
    "command": "rudder chat messages <chat-id-or-cht-ref> [--limit <n>] [--cursor <cursor>] [--include-transcript]",
    "contract": "agent-v1",
    "description": "Read bounded chat messages with page cursors; transcript output is omitted unless requested.",
    "id": "chat.messages",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "chat",
    "command": "rudder chat transcript <chat-id-or-cht-ref> [--limit <n>] [--cursor <cursor>] [--max-output-chars <n>]",
    "contract": "agent-v1",
    "description": "Read paginated chat messages with assistant transcript entries clipped in human output.",
    "id": "chat.transcript",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "chat",
    "command": "rudder chat read <chat-id-or-cht-ref> [--turn-limit <n>] [--cursor <cursor>] [--include-output]",
    "contract": "agent-v1",
    "description": "Read a bounded recent-message snapshot for one chat with page cursors.",
    "id": "chat.read",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "chat",
    "command": "rudder chat create --org-id <id> --body <text>",
    "contract": "agent-v1",
    "description": "Create a chat conversation with its first message.",
    "id": "chat.create",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "chat",
    "command": "rudder chat send <chat-id-or-cht-ref> --body <text>",
    "contract": "agent-v1",
    "description": "Send an agent-authored message directly to the operator in a chat.",
    "id": "chat.send",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "chat",
    "command": "rudder chat archive <chat-id-or-cht-ref>",
    "contract": "agent-v1",
    "description": "Archive a chat conversation without deleting it.",
    "id": "chat.archive",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs list --org-id <id> [--used-skill <skill>] [--loaded-skill <skill>] [--cursor <cursor>] [--full]",
    "contract": "agent-v1",
    "description": "List lightweight run summaries with stable pagination and filters; use --full only for legacy full-row compatibility.",
    "id": "runs.list",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs by-skill <skill> --org-id <id> [--evidence <used-or-loaded>] [--cursor <cursor>] [--full]",
    "contract": "agent-v1",
    "description": "Build a paginated skill evidence packet from lightweight run summaries; use --full only for legacy full-row compatibility.",
    "id": "runs.by-skill",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": true,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs get <run-id> [--full]",
    "contract": "agent-v1",
    "description": "Read one bounded run summary; use --full only from a direct trusted CLI for raw detail.",
    "id": "runs.get",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs events <run-id> [--cursor <cursor>] [--after-seq <n>] [--limit <n>] [--full]",
    "contract": "agent-v1",
    "description": "List a bounded page of persisted run events with a lossless opaque cursor and clipped payload previews.",
    "id": "runs.events",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs log <run-id> [--offset <bytes>] [--limit-bytes <n>]",
    "contract": "agent-v1",
    "description": "Read a bounded byte range of stored run log content.",
    "id": "runs.log",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs transcript <run-id> [--turn-limit <n>] [--cursor <cursor>] [--include-output] [--full]",
    "contract": "agent-v1",
    "description": "Read a compact server-normalized transcript; --json changes encoding only and --full is direct-CLI-only raw access.",
    "id": "runs.transcript",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": false,
    "category": "runs",
    "command": "rudder runs errors <run-id>",
    "contract": "agent-v1",
    "description": "List failed tool calls, stderr, runtime failures, and jump-to-context commands.",
    "id": "runs.errors",
    "mutating": false,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "runs",
    "command": "rudder runs cancel <run-id>",
    "contract": "agent-v1",
    "description": "Cancel a heartbeat run through the governed server route.",
    "id": "runs.cancel",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "runs",
    "command": "rudder runs retry <run-id>",
    "contract": "agent-v1",
    "description": "Retry a failed, timed out, or cancelled run through the governed server route.",
    "id": "runs.retry",
    "mutating": true,
    "requiresAgentId": false,
    "requiresOrgId": false,
    "requiresRunId": false
  },
  {
    "attachesRunIdWhenAvailable": true,
    "category": "runs",
    "command": "rudder runs create --task <text> --idempotency-key <key> [--target-agent-id <id>]",
    "contract": "agent-v1",
    "description": "Create an independently governed Delegation Run for the current or another same-organization Agent.",
    "id": "runs.create",
    "mutating": true,
    "requiresAgentId": true,
    "requiresOrgId": false,
    "requiresRunId": true
  }
];
